import { Typography } from "@mui/material";
import Select from "@mui/material/Select";

import defaultStyles from "./styles";

interface StyledSelectProps {
  children?: React.ReactNode;
  styles?: object;
  label?: string;
  noBorder?: boolean;
  [rest: string]: any;
}

export default function StyledSelect({
  children,
  styles = {},
  label = "",
  noBorder = false,
  ...rest
}: StyledSelectProps) {
  return (
    <>
      {label && <Typography gutterBottom>{label}</Typography>}
      <Select
        {...rest}
        sx={[noBorder ? defaultStyles.noBorder : defaultStyles.root, styles]}
      >
        {children}
      </Select>
    </>
  );
}
